import React from 'react'
import {UseFormMethods} from 'react-hook-form'
import {AgendaListProps} from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem/AgendaList'
import OffsetInputs from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem/OffsetInputs'

export default function Styling(props: {
  control: UseFormMethods['control']
  list: AgendaListProps
}) {
  return (
    <OffsetInputs
      control={props.control}
      offsetTop={props.list.offsetTop}
      offsetBottom={props.list.offsetBottom}
    />
  )
}
